/**
 * Mask User Email Address
 *
 * Shows the first 2 characters of both the local part and the domain,
 * masking the rest of each. Example: "em****@in*********"
 *
 * @param {string} email
 *
 * @return {string} maskedEmail
 */
function maskedUserEmail(email) {
    if (!email || !email.includes("@")) {
        return "";
    }

    const [local, domain] = email.split("@");
    const maskedLocal = local.substring(0, 2) + "*".repeat(Math.max(local.length - 2, 2));

    const dotIndex = domain.indexOf(".");
    const domainName = domain.substring(0, dotIndex);
    const tld = domain.substring(dotIndex);
    const maskedDomain = domainName.substring(0, 2) + "*".repeat(Math.max(domainName.length - 2, 2)) + tld;

    return `${maskedLocal}@${maskedDomain}`;
}

/* Exporting */
export const emailFilter = {
    maskedUserEmail,
};
